<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="4">
      <v-card color="primary">
        <v-card-title>
          <v-text-field v-model="search" dark append-icon="mdi-magnify" />
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="users"
            :headers="columns"
            :search="search"
            dark
            class="secondary"
            @click:row="userSelect" />          
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="1" />
    <v-col cols="12" md="2">
      <v-card v-if="chosenUser.name" color="secondary" dark>
        <v-card-title>
          {{ chosenUser.name }}
        </v-card-title>
        <v-card-text>
          <v-sheet color="primary">
            <v-switch v-model="chosenUser.user" label="User" color="accent" class="justify-center" />
            <v-switch v-model="chosenUser.admin" label="Admin" class="justify-center" />
            <v-btn @click="saveUser()" color="accent">Save</v-btn>              
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      search: '',
      columns: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'E-Mail',
          value: 'email'
        }
      ],
      chosenUser: {}
    };
  },
  created() {
    this.fetchUsers();
  },
  computed: {
    ...mapState(['users'])
  },
  methods: {
    ...mapActions(['fetchUsers', 'updateUser']),
    userSelect(userInfo) {
      this.chosenUser = userInfo;
    },
    saveUser() {
      this.updateUser(this.chosenUser);
      this.chosenUser = {};
    }
  }
};
</script>

<style>

</style>